export default {
  TITLE: '404',
  SUB_TITLE: 'Page not found',
  DESCRIPTION: "That's ruff...it looks like this page was lost in translation.",
  SUB_DESCRIPTION: ' On the bright side, you helped Snow, our office dog, find her ball!',
  SUPPORT: 'Feel free to reach out to us at',
  SUPPORT_EMAIL: 'support@getblend.com',
  HINT: "Maybe you'll find what you're looking for here:",
};
